import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import Label from '../Label';
import { Textarea } from './index';
export const TextareaField = memo(function TextareaField({ input, meta, label, labelTooltip, required, disabled, rows, ...props }) {
    return (_jsxs(_Fragment, { children: [label ? (_jsx(Label, { disabled: disabled, required: required, tooltip: labelTooltip, children: label })) : null, _jsx(Textarea, { ...input, error: meta.touched && (meta.error || meta.submitError), disabled: disabled, rows: rows, ...props })] }));
});
